import { Injectable, inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Observable } from 'rxjs';
import { EkBreakpointService } from 'app/modules/admin/shared/services/ek-breakpoint.service';

/**
 * @deprecated Inject {@link EkBreakpointService} instead.
 *
 * Retained as a thin delegating shim so its two remaining consumers
 * (`app.component.ts`, `blog.component.ts`) keep working. Delete once
 * `blog.component.ts` is migrated in a later step.
 *
 * BEHAVIOUR CHANGE: this used to hardcode a 768px breakpoint, which matched
 * neither `tailwind.config.js` nor the layout's own drawer breakpoint. It now
 * resolves to the shared `md` breakpoint (960px), so "mobile or tablet" means
 * the same thing here as it does in templates and in the nav drawer.
 * Between 768px and 960px, `blog.component.ts` now reports mobile where it
 * previously reported desktop.
 */
@Injectable({
    providedIn: 'root',
})
export class ScreenService {
    private readonly _breakpoints = inject(EkBreakpointService);
    private readonly _isMobileOrTablet$ = toObservable(
        this._breakpoints.isCompactLayout
    );

    /**
     * @deprecated No-op. EkBreakpointService tracks resizes itself via
     * FuseMediaWatcherService, so callers no longer need to poke it.
     */
    updateScreenSize(): void {
        // Intentionally empty — kept so existing callers still compile.
    }

    /** @deprecated Use `EkBreakpointService.isCompactLayout` (a signal). */
    isMobileOrTablet$(): Observable<boolean> {
        return this._isMobileOrTablet$;
    }

    /** @deprecated Use `EkBreakpointService.isCompactLayout()`. */
    isMobileOrTablet(): boolean {
        return this._breakpoints.isCompactLayout();
    }
}
